var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgToggleRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 7.06667C5.91015 7.06667 3 10.1708 3 14C3 17.8292 5.91015 20.9333 9.5 20.9333H17.5C21.0899 20.9333 24 17.8292 24 14C24 10.1708 21.0899 7.06667 17.5 7.06667H9.5ZM2 14C2 9.58172 5.35786 6 9.5 6H17.5C21.6421 6 25 9.58172 25 14C25 18.4183 21.6421 22 17.5 22H9.5C5.35786 22 2 18.4183 2 14ZM17.5 11.3333C16.1193 11.3333 15 12.5272 15 14C15 15.4728 16.1193 16.6667 17.5 16.6667C18.8807 16.6667 20 15.4728 20 14C20 12.5272 18.8807 11.3333 17.5 11.3333ZM14 14C14 11.9381 15.567 10.2667 17.5 10.2667C19.433 10.2667 21 11.9381 21 14C21 16.0619 19.433 17.7333 17.5 17.7333C15.567 17.7333 14 16.0619 14 14Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgToggleRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/toggle-right.44271b6c.svg";
export { ForwardRef as ReactComponent };